var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticClass:"responsive-iframe",attrs:{"id":"preview","src":_vm.customExtension.url,"width":"100%","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }